import React from 'react';
import NavigationBar from '../../components/NavigationBar/NavigationBar';

function About() {
  return (
    <div>
      <NavigationBar />
      <main>
        <h1>About Us</h1>
        <p>Text content goes here...</p>
      </main>
    </div>
  );
}

export default About;
